import { render, staticRenderFns } from "./keywordReply.vue?vue&type=template&id=5232fb19&scoped=true&"
import script from "./keywordReply.vue?vue&type=script&lang=ts&"
export * from "./keywordReply.vue?vue&type=script&lang=ts&"
import style0 from "./keywordReply.vue?vue&type=style&index=0&id=5232fb19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5232fb19",
  null
  
)

export default component.exports